import { ReactComponent as WarningIcon } from "assets/icons/warning.svg";
import Link from "components/Link";
import useLocalizedRoutes from "hooks/useLocalizedRoutes";
import { Text } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";
import PasswordRequirementsPopup from "../PasswordRequirementsPopup";

interface Props {
  visible: boolean;
  onClose: () => void;
}

const PasswordRequirementsErrorPopup: React.FC<Props> = ({
  visible,
  onClose,
}) => {
  const { t } = useTranslation();
  const { getLanguageRoute } = useLocalizedRoutes();

  return (
    <PasswordRequirementsPopup
      visible={visible}
      onClose={onClose}
      onClickButton={onClose}
      buttonText={t("3442") /* Fechar */}
      icon={<WarningIcon />}
    >
      <Text elementType="p" variant="body6">
        {t("7987") /* Caro(a) Utilizador(a) */}
      </Text>
      <Text className="mt-10" elementType="p" variant="body6">
        {
          t(
            "7991"
          ) /* Para continuar a aceder à plataforma, deve proceder à recuperação
          da sua palavra-passe e definir uma nova que cumpra com os requisitos. */
        }
      </Text>
      <Text elementType="p" variant="body6">
        <b>
          <Link underline="always" to={getLanguageRoute("passwordRecovery")}>
            {
              t(
                "8199"
              ) /* Clique aqui para alterar a sua palavra-passe agora. */
            }
          </Link>
        </b>
      </Text>
    </PasswordRequirementsPopup>
  );
};

export default PasswordRequirementsErrorPopup;
